export default __webpack_public_path__ + "static/media/image1.c8d9527c.jpg";